import React, { useRef } from 'react';
import styled from 'styled-components';
import { t } from 'ttag';
import { XIcon } from '@heroicons/react/solid';

import { ButtonPrimarySmall } from '../Button/Button';
import { useOutsideClick } from '../../../hooks/useOutsideClick';

const FilterPopupWrap = styled.div`
  position: absolute;
  z-index: 999;
  ${(props) => props.popupDirection === 'right' && { right: '0px' }};
  ${(props) => props.popupDirection === 'left' && { left: '0px' }};
  ${(props) => props.popupPosition === 'bottom' && { top: 'calc(100% + 8px)' }};
  ${(props) => props.popupPosition === 'top' && { bottom: '50px' }};
  background: white;
  width: auto;
  min-width: 300px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  padding: ${({ theme }) => theme.spacing02};
  border-radius: ${({ theme }) => theme.borderRadius};
  .filter-popup-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${({ theme }) => theme.spacing01};
  }
  .filter-popup-close-icon {
    width: ${({ theme }) => theme.spacing03};
    cursor: pointer;
    color: ${({ theme }) => theme.colorUI80};
  }
  .filter-popup-top-label {
    font-size: ${({ theme }) => theme.fontSize03};
    color: ${({ theme }) => theme.colorText50};
    font-weight: ${({ theme }) => theme.fontWeightMedium};
  }
  .filter-popup-close-button {
    width: ${({ theme }) => theme.spacing04};
    height: ${({ theme }) => theme.spacing04};
    border: none;
    border-radius: ${({ theme }) => theme.borderRadius};
    background: none;
    transition: ${({ theme }) => theme.hoverTransitionSpeed} linear background;
    :hover {
      background: ${({ theme }) => theme.colorUI20};
      transition: ${({ theme }) => theme.hoverTransitionSpeed} linear background;
    }
  }
  ${ButtonPrimarySmall} {
  }

  .filter-popup-bottom {
    border-top: 1px solid ${({ theme }) => theme.colorUI30};
    padding-top: ${({ theme }) => theme.spacing02};
    margin-top: ${({ theme }) => theme.spacing02};
    width: 100%;
  }

  .filter-popup-content {
    width: 100%;
    max-height: 300px;
    ${(props) => props.size === 'small' && { maxHeight: '200px' }};
    overflow-y: scroll;
  }
`;

const FilterPopup = React.forwardRef(
  (
    {
      popupPosition = 'bottom',
      shouldDisplaySaveChangesButton = true,
      children,
      label,
      onClosePopupClick,
      onSaveChangesClick,
      popupDirection = 'left',
      className,
      onOutsideClick,
      size,
    },
    ref,
  ) => {
    const filterPopupRef = useRef();
    useOutsideClick([filterPopupRef, ref], onOutsideClick);

    return (
      <FilterPopupWrap
        ref={(el) => (filterPopupRef.current = el)}
        className={className ? className : ''}
        popupPosition={popupPosition}
        popupDirection={popupDirection}
        size={size}
      >
        <div className="filter-popup-top">
          <label className="filter-popup-top-label" htmlFor="">
            {label}
          </label>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onClosePopupClick();
            }}
            className="filter-popup-close-button"
          >
            <XIcon className="filter-popup-close-icon" />
          </button>
        </div>
        <div className="filter-popup-content">{children}</div>
        {shouldDisplaySaveChangesButton ? (
          <div className="filter-popup-bottom">
            <ButtonPrimarySmall
              onClick={(e) => {
                e.stopPropagation();
                onSaveChangesClick();
              }}
            >
              {t`Save changes`}
            </ButtonPrimarySmall>
          </div>
        ) : null}
      </FilterPopupWrap>
    );
  },
);

FilterPopup.displayName = 'FilterPopup';

export default FilterPopup;
